import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Ė",
  "use": "icon-Ė-usage",
  "viewBox": "0 0 61 60",
  "content": "<symbol viewBox=\"0 0 61 60\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Ė\">\n<path d=\"M33.5267 19.432C33.5267 17.656 33.7187 16.696 36.3587 16.696H39.8627V9.784H34.2467C27.4307 9.784 25.0307 13.144 25.0307 18.76V22.888H20.8067V29.8H25.0307V49.816H33.5267V29.8H39.1907L39.9107 22.888H33.5267V19.432Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol